// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { ContextualMessage } from "src/modules/simulation-panel/jsx/contextual-message.jsx";

// Stateful components

export class MyDetails extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {

        super(props);

        this.state = {
           "my_details": null
        };

        // Binds
        this.renderMyDetails = this.renderMyDetails.bind(this);
    }

    componentDidMount(){
        var this_component = this;

        var my_details_storage = squiz.fn.getStorage('getmydetails', 'session', 'json');
        if (my_details_storage && my_details_storage['data']) {
            
            my_details_storage = my_details_storage['data'];

            this_component.setState({
                "my_details": my_details_storage
            });
        }

    }

    // Functions

    // Generate users name
    generateContactName(data){
        // initial run is null
        if(data){
            var name_compiled = [];
            var first_name = data['firstName'];
            var middle_name = data['middleName'];
            var last_name = data['lastName'];
    
            if(typeof first_name != 'undefined' && first_name.length > 0){
                name_compiled.push(first_name);
            }
            if(typeof middle_name != 'undefined' && middle_name.length > 0){
                name_compiled.push(middle_name);
            }
            if(typeof last_name != 'undefined' && last_name.length > 0){
                name_compiled.push(last_name);
            }
    
            if(name_compiled.length > 0){
                return name_compiled.join(' ');
            }
        }
        
        return null;
    }
    // Generate users Phone number
    generateContactPhone(data){
        // initial run is null
        if(data){
            // make sure there is some data to use
            if(typeof data['phoneNumbers'] != 'undefined' && data['phoneNumbers'].length > 0){
                var preferred_number = '';
                for(var index = 0; index < data['phoneNumbers'].length; index++){
                    var isPreferred = data['phoneNumbers'][index]['isPreferred'];
                    // if isPreferred number - use it. ignore the rest.
                    if(typeof isPreferred != 'undefined' && isPreferred){
                        preferred_number = data['phoneNumbers'][index]['number'];
                        break;
                    }
                }
                // return the number if not empty
                if(preferred_number != ''){
                    return preferred_number;
                }
            }
        }

        return null;
    }
    // Generate users Mailing address
    generateContactAddressMailing(data){
        // initial run is null
        if(data){
            if(typeof data['postalAddress'] != 'undefined'){
                var address_compiled = [];
                for(var key in data['postalAddress']){
                    if(data['postalAddress'][key]){
                        address_compiled.push(data['postalAddress'][key]);
                    }
                }
                if(address_compiled.length > 0){
                    return address_compiled.join(' ');
                }
            }
        }

        return null;
    }
    // Generate users Residential address
    generateContactAddressResidential(data){
       // initial run is null
       if(data){
        if(typeof data['homeAddress'] != 'undefined'){
            var address_compiled = [];
            for(var key in data['homeAddress']){
                if(data['homeAddress'][key]){
                    address_compiled.push(data['homeAddress'][key]);
                }
            }
            if(address_compiled.length > 0){
                return address_compiled.join(' ');
            }
        }
    }

    return null;
    }
    // Generate Emergency contact array
    generateEmergencyContact(data){
        // initial run is null
        if(data){
            if(data['emergencyContacts'] && data['emergencyContacts'].length > 0){
                var emergency_contacts = [];
                
                for(var index = 0; index < data['emergencyContacts'].length; index++){
                    var this_contact = data['emergencyContacts'][index];

                    var emergency_contact = {
                        "name": 'Not stated.',
                        "number": 'Not stated.',
                        "isPrimary": false
                    };

                    // look for contact name
                    if(this_contact['name'] && this_contact['name'].length > 0){
                        emergency_contact['name'] = this_contact['name'];
                    }

                    // look for isPrimary flag
                    if(this_contact['isPrimary']){
                        emergency_contact['isPrimary'] = true;
                    }

                    // look for phone data
                    if(this_contact['phones'] && this_contact['phones'].length > 0){
                        var phone_content = '';
                        var phone_count = this_contact['phones'].length;
                        for(var phone_index = 0; phone_index < phone_count; phone_index++){
                            var this_phone = this_contact['phones'][phone_index];
                            
                            // add the phone type if there are more than one contact points
                            if(phone_count > 1){
                                if(this_phone['phoneType']){
                                    var output = this_phone['phoneType'];
                                    if(output.toLowerCase() == 'cell'){
                                        output = 'MOBILE';
                                    }
                                    output += ': ';
                                    phone_content += output
                                }
                            }
                            if(this_phone['countryCode']){
                                var output = this_phone['countryCode'];
                                output += ' ';
                                phone_content += output
                            }
                            if(this_phone['number']){
                                var output = this_phone['number'];
                                output += ' ';
                                phone_content += output
                            }
                            if(this_phone['extension']){
                                var output = '(Ext: ' + this_phone['extension'] + ') ';
                                phone_content += output
                            }
                            // add a break so the next line can be printed (when more than 1 contact points)
                            if(phone_count > 1){
                                phone_content += '<br />';
                            }
                        }
                        emergency_contact['number'] = phone_content;
                    }

                    emergency_contacts.push(emergency_contact);
                }

                // Move primary contacts to front of the list
                emergency_contacts.sort(function(a, b) {
                    if (!a['isPrimary'] && b['isPrimary']) {
                        return 1;
                    }
                    if (a['isPrimary'] && !b['isPrimary']) {
                        return -1;
                    }
                    return 0;
                });

                if(emergency_contacts != []){
                    return emergency_contacts;
                }
            }
        }

        return null;
    }


    //
    // Render
    //
    renderMyDetails(){
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        
        var sNumber = portal_context['user_personalisation']['sNumber'];
        
        var my_details = this_component['state']['my_details'];

        // Contact info
        var contact_name = this_component.generateContactName(my_details);
        var contact_number = this_component.generateContactPhone(my_details);
        var contact_address_mailing = this_component.generateContactAddressMailing(my_details);
        var contact_address_residential = this_component.generateContactAddressResidential(my_details);
        // emergency contact info
        var emergency_contacts = this_component.generateEmergencyContact(my_details);
        
        var edit_url = null;
        edit_url = helpers.generateStudentCentreUrl('889864');
       

        return (
            <>
                <div className="page-inner__content">
                    <div className="my-details__section__container">
                        <div className="my-details__section">

                            <div className="my-details__content">
                                <div className="my-details__content__header">
                                    <h2 className="my-details__content__header__title">
                                        Contact details
                                    </h2>
                                    <a href={edit_url}  className="my-details__content__header__edit">
                                        Edit
                                        <span className="my-details__header__edit__button">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25">
                                            <path
                                                d="M1 24.25a.79.79 0 01-.53-.22.73.73 0 01-.18-.76l1.88-5.84a.67.67 0 01.19-.3L18.47 1a.75.75 0 011.06 0l4 4a.75.75 0 010 1.06l-16.23 16a.79.79 0 01-.29.18l-5.77 2a.67.67 0 01-.24.01zm2.55-6.19l-1.38 4.25 4.2-1.43L21.94 5.5 19 2.56 3.55 18.06z" />
                                            <path
                                                d="M20.38 8.68a.73.73 0 01-.53-.22L16 4.58a.75.75 0 010-1.06.77.77 0 011.07 0l3.88 3.88a.75.75 0 01-.57 1.28zM7.53 21.53a.74.74 0 01-.53-.22l-3.88-3.88a.75.75 0 111.06-1.06l3.88 3.88a.75.75 0 01-.53 1.28z" />
                                        </svg>
                                        </span>
                                    </a>
                                </div>
                                <ContextualMessage id="student_details" />
                                <div className="my-details__content__wrapper">
                                    <div className="my-details__content__item">
                                        <h3 className="my-details__content__item__title">
                                            Legal name
                                        </h3>
                                        <div className="my-details__content__item__value">
                                            {contact_name}
                                        </div>
                                    </div>
                                    <div className="my-details__content__item">
                                        <h3 className="my-details__content__item__title">
                                            Phone number
                                        </h3>
                                        <div className="my-details__content__item__value">
                                            {contact_number}
                                        </div>
                                    </div>
                                    <div className="my-details__content__item">
                                        <h3 className="my-details__content__item__title">
                                            Mailing address
                                        </h3>
                                        <div className="my-details__content__item__value">
                                            {contact_address_mailing}
                                        </div>
                                    </div>
                                    <div className="my-details__content__item">
                                        <h3 className="my-details__content__item__title">
                                            Residential address
                                        </h3>
                                        <div className="my-details__content__item__value">
                                        {contact_address_residential}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-details__content">
                                <div className="my-details__content__wrapper">
                                <div className="my-details__content__item">
                                    <h3 className="my-details__content__item__title">
                                        Student Number
                                    </h3>
                                    <div className="my-details__content__item__value">
                                        {sNumber}
                                    </div>
                                </div>
                                </div>

                            </div>
                            <div className="my-details__content">
                                <div className="my-details__content__header">
                                    <h2 className="my-details__content__header__title">
                                        Emergency contact
                                    </h2>
                                    <a href={edit_url} className="my-details__content__header__edit">
                                        Edit
                                        <span className="my-details__header__edit__button">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25">
                                            <path
                                                d="M1 24.25a.79.79 0 01-.53-.22.73.73 0 01-.18-.76l1.88-5.84a.67.67 0 01.19-.3L18.47 1a.75.75 0 011.06 0l4 4a.75.75 0 010 1.06l-16.23 16a.79.79 0 01-.29.18l-5.77 2a.67.67 0 01-.24.01zm2.55-6.19l-1.38 4.25 4.2-1.43L21.94 5.5 19 2.56 3.55 18.06z" />
                                            <path
                                                d="M20.38 8.68a.73.73 0 01-.53-.22L16 4.58a.75.75 0 010-1.06.77.77 0 011.07 0l3.88 3.88a.75.75 0 01-.57 1.28zM7.53 21.53a.74.74 0 01-.53-.22l-3.88-3.88a.75.75 0 111.06-1.06l3.88 3.88a.75.75 0 01-.53 1.28z" />
                                        </svg>
                                        </span>
                                    </a>
                                </div>
                                <ContextualMessage id="emergency_details" />

                                <div className="my-details__content__wrapper">
                                    {emergency_contacts ? 
                                        emergency_contacts.map(function(contact, key) {

                                            var contact_number_HTML;
                                            if(contact && contact['number']){
                                                contact_number_HTML = {
                                                    '__html': contact['number']
                                                };
                                            }
                                            return (
                                                <React.Fragment key={key}>
                                                    <div className="my-details__content__item">
                                                        <h3 className="my-details__content__item__title">
                                                            Contact name
                                                        </h3>
                                                        <div className="my-details__content__item__value">
                                                            {contact['name']}
                                                        </div>
                                                    </div>
                                                    <div className="my-details__content__item">
                                                        <h3 className="my-details__content__item__title">
                                                            Contact number
                                                        </h3>
                                                        <div className="my-details__content__item__value">
                                                            <span dangerouslySetInnerHTML={contact_number_HTML}></span>
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            )
                                        })
                                        
                                        : 
                                            
                                        <p>You have not added an Emergency contact. Click the Edit button to add one now.</p>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }

    render() {
        var this_component = this;
        
        return (
            <>
                <this_component.renderMyDetails />
            </>
        );
    }

};

MyDetails.contextType = PortalContext;
